import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import animationData from '../assets/work_to_gather_grwoth.json';
import { motion } from "framer-motion";
import { TypeAnimation } from "react-type-animation";
import DeviceShowcase from './DeviceShowcase';
import SEO from '../components/SEO';


const Portfolio = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      <SEO
        title="Portfolio | Lavanya Infotech"
        description="Explore our portfolio to see how Lavanya Infotech has helped clients across the globe with elegant websites, branding, UI/UX, and custom software solutions."
      />
      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-4 pb-16">

        {/* Left Content */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="w-full md:w-7/12 text-center md:text-center"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight space-y-3">
            <div>
              <span className="text-[#aab863]">We</span>{" "}
              <span className="text-white">Showcase</span>{" "}
              <span className="text-[#aab863]">Our</span>{" "}
              <span className="text-[#c96c4e]">Portfolio</span>
            </div>
          </h1>

          <div className="text-slider pt-2 mt-10 text-left mb-10 overflow-hidden h-10 w-full">
            <div className="animated-texts animate-slide-up text-xl font-semibold">
              <span className="block text-left text-blue-300 border-b-4 border-blue-300">Web Development</span>
              <span className="block text-left text-green-300 border-b-4 border-green-300">Shopify Shop</span>
              <span className="block text-left text-purple-300 border-b-4 border-purple-300">Full-Stack Development</span>
              <span className="block text-left text-yellow-300 border-b-4 border-yellow-300">Customer Service</span>
            </div>
          </div>


        </motion.div>

        {/* Lottie Animation */}
        <div className="w-full md:w-5/12 flex justify-center md:justify-center mt-10 md:mt-0">
          <Lottie
            animationData={animationData}
            loop
            autoplay
            className="w-[250px] sm:w-[250px] md:w-[300px] lg:w-400px]"
          />
        </div>
      </div>

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight space-y-3 text-center pb-5">
        <div className="inline-block">
          <span className="text-white">Projects Showcasing Our </span>
          <TypeAnimation
            className="text-[#cbdfbd] inline-block"
            sequence={[
              "Innovation", 4000,
              "Expertise", 4000,
              "Scalability", 4000,
              "Security", 4000,
              "Efficiency", 4000
            ]}
            wrapper="span"
            speed={50}
            repeat={Infinity}
            cursor={false}
          />
        </div>
      </h1>




      <h3 className="font-poppins text-center text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16">
        Web Development
      </h3>


      <DeviceShowcase />

      {/* <h3 className="font-poppins text-center text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16">
        Bussiness Card
      </h3>


      <h3 className="font-poppins text-center text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16">
        Shopify Store
      </h3>


      <h3 className="font-poppins text-center text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16">
        Social Media Marketing
      </h3> */}

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

    </div>
  )
}

export default Portfolio